<template>
	<div class="block md-elevation-4" :key="id" v-if="id !== undefined">
		<div class="header" style="min-height: 40px; width: 100%">
			<div v-if="" style="margin-right: auto; margin-left: 0; width: max-content">
				<span
					><el-button @click="OpenPreview"> <md-icon>slideshow</md-icon> </el-button>
				</span>



				<wizard-modal
					@add='(valuetoadd)=>fakeAdd(valuetoadd)'
					v-if="openWizard"
					:show="openWizard"
					:wizard_id="node_value(this.id).originale"
					@close="
						() => {
							openWizard = false
						}
					"
				></wizard-modal>
			</div>

			<span  v-if='type==="wizard"'
			><el-button @click="gotoOther()"> vai a  </el-button>
				</span>

			<md-button v-if="id" class="md-icon-button" @click="del(id)">
				<md-icon>close</md-icon>
			</md-button>
			<!--        <md-button class="md-icon-button" @click="editOptions(id)">-->
			<!--        <md-icon>edit</md-icon>-->
			<!--      </md-button>-->
		</div>
		<div class="body">
			<el-tooltip
				v-if="changeNodeName == false"
				:disabled="true"
				class="item"
				effect="dark"
				:content="$t('tooltip-edit')"
				placement="top"
			>
				<div @dblclick="changeNodeName = true" class="titolos">
					{{ titolos }}
				</div>
			</el-tooltip>
			<div v-else class="titolos">
				<input @keyup.enter="changeNodeName = false" v-model="titolos" />
				<el-button
					style="margin: 10px"
					@keyup.enter="changeNodeName = false"
					@click="changeNodeName = false"
					type="primary"
					>Ok
				</el-button>
			</div>
			<div style="display: flex; justify-content: center; align-items: center" v-if="question">
				<div style="padding: 15px" :key="question.value + id + questioning">
					<!--

					What the Fuck Did I Just Bring Upon This Cursed Land

					-->
					<div v-if="id == 0">
						<el-button v-if="questioning" @click="setQuestion(id)" type="warning">
							{{ $t("set-question") }}
						</el-button>
						<el-button v-else @click="showQuestion(id)" type="danger">{{ $t("show-question") }}</el-button>
					</div>
					<div v-else>
						<el-button @click="setValue(id)" type="success">
							{{ $t("set-value") }}
						</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import { connectionRemoved } from "@/modules/wizard/wizard-utils"
import WizardModal from "@/modules/wizard/modals/wizard-modal"
import { goto } from '@/utils/utils'
export default {
	name: "wizard-block",
	props: ["id"],
	components: {
		WizardModal
	},
	data() {
		return {
			hover: undefined,
			changeNodeName: false,
			openWizard: false
		}
	},
	computed: {
		children() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined)
				return this.node_value(this.id).children
		},
		parent() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined) return this.node_value(this.id).parent
		},
		question() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined)
				return this.node_value(this.id).question
		},
		titolo() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined) return this.node_value(this.id).titolo
		},
		id_destination() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined) return this.node_value(this.id).value[0].id
		},
		value() {
			if (this.id !== undefined && this.node_value(this.id) !== undefined) return this.node_value(this.id).value
		},
		type() {


			if (this.nodes.find(i => i.id == this.id)) return this.nodes.find(i => i.id == this.id).value[0].type

		},
		...mapGetters({
			node_value: "wizard/node_value",
			editor: "wizard/editor",
			showModalEdit: "wizard/showModalEdit",
			selected_id: "wizard/selected_id",
			nodes: "wizard/nodes",
			isQuestion: "wizard/isQuestion"
		}),
		questioning() {
			return this.isQuestion(this.id)
		},
		titolos: {
			get() {
				return this.titolo
			},
			set(val) {
				var tmp = this.nodes.find(i => i.id == this.id)
				tmp.titolo = val
				this.editVal({ node_id: this.id, val: tmp })
			}
		},
		identificativo() {
			return this.nodes.find(i => i.id == this.id).identificativo
		}
	},
	methods: {
	gotoOther(){

		this.$router.push("/wizards/"+this.id_destination)
//		this.$router.push(path)

	},
		OpenPreview() {
			this.$confirm(this.$t("preview-alert"), "Warning", {
				confirmButtonText: "OK",
				cancelButtonText: this.$t("cancel"),
				type: "warning"
			})
				.then(() => {
					this.openWizard = true
				})
				.catch(() => {})
		},

		connectionRemoved,
		...mapActions({
			delNode: "wizard/delNode",
			cloneNode: "wizard/cloneNode",
			editNode: "wizard/editNode",
			setQuestion: "wizard/setQuestion",
			showQuestion: "wizard/showQuestion",
			setValue: "wizard/setValue",
			removeQuestion: "wizard/removeQuestion",
			editModalEdit: "wizard/editModalEdit",
			editWikiModal: "wizard/editWikiModal",
			endSetQuestion: "wizard/endSetQuestion",
			resetQuestion: "wizard/resetQuestion"
		}),
		...mapMutations({
			editVal: "wizard/UPDATE_NODE"
		}),
		edit(id) {
			if (id !== undefined) {
				this.editModalEdit({ val: true, id: this.id })
			} else {
				this.editModalEdit({ val: false, id: undefined })
			}
		},
		wiki() {
			this.editWikiModal({ val: true, id: this.id })
		},

		del(id) {
			this.delNode(id)
		},
		clone(id) {
			this.cloneNode({ node_id: id, store: this.$store })
		},
		removeQuestion(id) {
			this.resetQuestion(id)
			this.editDialog = false
			this.endSetQuestion()
		},
		editOptions(id) {
			this.editNode({ val: true, node_id: id })
		},
		fakeAdd(val){
			this.$message(this.$t("successful-add")+" "+val.name);
		},
	}
}
</script>
<style scoped lang="scss">
.block {
	min-height: 150px;
	background-color: white;
	border-radius: 10px;
}

.header {
	background-color: #ffffff;
	display: flex;
	justify-content: flex-end;

	.md-button {
		margin-left: 15px;
		margin-right: 5px;
	}

	input {
		min-width: 100px;
		margin-top: auto;
		margin-bottom: auto;
		margin-left: 10px;
	}

	border-radius: 10px 10px 0 0;
}

.titolos {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 26px;
	margin-bottom: 35px;
}

.body {
	padding: 10px;
	width: 100%;

	textarea {
		width: 100%;
	}
}

input {
	padding: 7px;
	border: 2px solid lightgray;
	border-radius: 15px;
}
</style>
